<template>
  <div class="cover_container">
    <div class="other-container global-full-fixed global-blur" :style="'background-image:url('+covericon03+');'"></div>
    <div class="cart-containers">
      <div class="cart_title">
        <img :src="covericon01" alt="">
        <p>用你的名片打动世界</p>
      </div>
      <div class="creatmpbtn">
        <a id="call-app" @click="appDownload" ref="callApp" href="javascript:void(0);" style="display: inline-block;float:right;">
          <div class="intoR">
            <img class="intoR_img" :src="covericon04" alt="">
            <span>立即下载</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "vant";

Vue.use(Dialog);
export default {
  name: "appdownload",
  data () {
    return {
      download_url_Adr: 'https://xianpipa.com/download/xianpipa.apk',
      download_url_IOS: 'https://itunes.apple.com/cn/app/id1493255034?mt=8',
      covericon01: require("../../assets/images/cover_logo.png"),
      covericon03: require("../../assets/images/cover_icon_02.png"),
      covericon04: require("../../assets/images/cover_icon_03.png")
    };
  },
  created () {
  },
  methods: {
    appDownload () {
      let { isAndroid, isIOS, isIOS9 } = this.detectVersion();
      if (isAndroid) {
        window.location.href = this.download_url_Adr;
      } else {
        window.location.href = this.download_url_IOS;
      }
    },
    detectVersion () {
      let u = navigator.userAgent;
      let ua = u.toLowerCase();
      let isAndroid, isIOS, isIOS9, version;
      if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        //android终端或者uc浏览器
        //Android系统
        isAndroid = true;
      }
      if (ua.indexOf("like mac os x") > 0) {
        //ios
        var regStr_saf = /os [\d._]*/gi;
        var verinfo = ua.match(regStr_saf);
        version = (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
      }
      var version_str = version + "";
      if (version_str != "undefined" && version_str.length > 0) {
        version = parseInt(version);
        if (version >= 8) {
          // ios9以上
          isIOS9 = true;
        } else {
          isIOS = true;
        }
      }
      return { isAndroid, isIOS, isIOS9 };
    },
  }
};
</script>

<style scoped>
.other-container {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}
.global-full-fixed {
  z-index: -1;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.cart-containers {
  width: 100%;
  height: calc(100% - 17rem);
  z-index: 99;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 8.5rem 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cart-containers .cart_title {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.cart-containers .cart_title > img {
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 0.5rem;
}
.cart-containers .cart_title > p {
  color: #fff;
  font-size: 0.9rem;
}

.popBox-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.6;
  z-index: 999;
  background-color: #000;
}

.popBox-content {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  width: 60%;
  font-size: 0.8648648648648649rem;
  border-radius: 0.7027027027027027rem;
  text-align: center;
}

.cover_container {
  background: #fff;
}

.creatmpbtn {
  margin: 0 auto;
  height: 2.4324324324324325rem;
  background: linear-gradient(90deg, #ffbd0a, #f9da5b);
  border-radius: 1.3513513513513513rem;
  text-align: center;
  line-height: 2.4324324324324325rem;
  color: #fff;
  font-size: 0.9rem;
  margin-left: 5rem;
  margin-right: 5rem;
  border: 0;
  position: relative;
}
.creatmpbtn .intoR_img {
  width: 1rem;
  height: 1rem;
  position: absolute;
  left: 1.8rem;
  top: 0.65rem;
}
.creatmpbtn a {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/appdownload.vue